/*
 * Copyright (C) Luna Srl - All Rights Reserved
 *
 * @project    bfree-frontend.nosync
 * @file       TriangleSelectedImage.tsx
 * @author     Christian Ascone
 * @date       9/23/19 12:24 PM
 */

import React from 'react';
import {Image} from "react-native";

export function TriangleSelectedImage(props) {
    return (
        <Image
            {...props}
            style={[props.style]}
            source={
                require('../../assets/images/triangle_selected.png')
            }
        />
    );
}